import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import SearchBar from "../../components/SearchBar";

const ManageTransaction = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  // Example transaction data
  const [transactions, setTransactions] = useState([
    {
      id: 1,
      transactionId: "TXN1001",
      orderId: "#1001",
      customer: "John Doe",
      totalAmount: "$50.00",
      commission: "$5.00",
    },
    {
      id: 2,
      transactionId: "TXN1002",
      orderId: "#1002",
      customer: "Jane Smith",
      totalAmount: "$30.00",
      commission: "$3.00",
    },
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Manage Revenue</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Revenue
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search Transactions..."
            />
          </div>
        </div>

        {/* Transaction Table */}
        <TableContainer className="table_container">
          <Table className="custom_table">
            <TableHead>
              <TableRow>
                <TableCell>Transaction ID</TableCell>
                <TableCell>Order ID</TableCell>
                <TableCell>Customer</TableCell>
                <TableCell>Total Amount</TableCell>
                <TableCell>Commission</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transactions
                .filter((t) =>
                  t.transactionId.toLowerCase().includes(searchTerm.toLowerCase()) ||
                  t.orderId.toLowerCase().includes(searchTerm.toLowerCase()) ||
                  t.customer.toLowerCase().includes(searchTerm.toLowerCase())
                )
                .map((txn) => (
                  <TableRow key={txn.id}>
                    <TableCell>{txn.transactionId}</TableCell>
                    <TableCell>{txn.orderId}</TableCell>
                    <TableCell>{txn.customer}</TableCell>
                    <TableCell>{txn.totalAmount}</TableCell>
                    <TableCell>{txn.commission}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default ManageTransaction;
